export default __webpack_public_path__ + "static/blob1-c88d974206ed63f0140b2bd1ab2e2807.svg";